import { UserContext } from '@digital-retail/falabella-ui-cross-components';
import createContainer from 'constate';
import { useState } from 'react';

function useUserContextHook() {
  // eslint-disable-next-line no-unused-vars
  const [_, userContext] = UserContext;
  const [tick, setTick] = useState(0);

  const {
    firstName,
    setFirstName,
    isUserLoggedIn,
    setUserLoggedIn,
    cartCount,
    setCartCount,
    lastName,
    isVendorLogin,
    vendorData,
    refreshUserData,
    getUserSegments,
    userSegments,
    setUserSegments,
  } = userContext();
  return {
    firstName,
    setFirstName,
    isUserLoggedIn,
    setUserLoggedIn,
    cartCount,
    setCartCount,
    lastName,
    isVendorLogin,
    vendorData,
    refreshUserData,
    getUserSegments,
    userSegments,
    tick,
    setTick,
    setUserSegments,
  };
}

const [UserProvider, useUser] = createContainer(useUserContextHook);

const withUser = (WrappedComponent) => {
  const { getInitialProps } = WrappedComponent;

  const ComponentWithUser = (props) => {
    const user = useUser();
    return <WrappedComponent {...props} {...user} />;
  };

  if (typeof getInitialProps === 'function') {
    ComponentWithUser.getInitialProps = getInitialProps;
  }

  return ComponentWithUser;
};

export { useUserContextHook as useUserContext, withUser, UserProvider, useUser };
